import { Resume } from 'packages/types'
import { Fragment } from 'react/jsx-runtime'
import { useI18n } from 'builder/hooks/useI18n'
import { SettingsFieldChangeHandler } from 'builder/modules/resumeEditor'
import { useFontSizeField } from '../../hooks/useFontSizesCustomization'
import { SliderContainer, SliderLabel } from '../../styles'
import { GenericAbsoluteSlider } from '../CustomizationSlider/GenericAbsoluteSlider'

type Props = {
  resume: Resume
  handleSettingsFieldChange?: SettingsFieldChangeHandler
}

const TRANSLATION = 'builder.resume_editor.document_customization.sidebar.text_tab'

export function FontSizesCustomization(props: Props) {
  const { i18n } = useI18n()

  const { getFontSizeField } = useFontSizeField(props.resume, props.handleSettingsFieldChange)

  const primaryFontSize = getFontSizeField('fontSizePrimaryHeading')
  const secondaryFontSize = getFontSizeField('fontSizeSecondaryHeading')
  const bodyFontSize = getFontSizeField('fontSizeBody')
  const sectionTitleFontSize = getFontSizeField('fontSizeSectionTitles')

  return (
    <Fragment>
      <SliderContainer>
        <SliderLabel>{i18n.t(`${TRANSLATION}.primary_heading_label`)}</SliderLabel>
        <GenericAbsoluteSlider
          value={primaryFontSize.value}
          defaultValue={primaryFontSize?.defaultValue}
          onChange={primaryFontSize.onChange}
          unit=" pt"
          isIntermediateDotsDisabled
          min={primaryFontSize?.min}
          max={primaryFontSize?.max}
          step={primaryFontSize?.step}
          isDisabled={false}
        />
      </SliderContainer>

      <SliderContainer>
        <SliderLabel>{i18n.t(`${TRANSLATION}.secondary_heading_label`)}</SliderLabel>
        <GenericAbsoluteSlider
          value={secondaryFontSize.value}
          defaultValue={secondaryFontSize?.defaultValue}
          onChange={secondaryFontSize.onChange}
          unit=" pt"
          isIntermediateDotsDisabled
          min={secondaryFontSize?.min}
          max={secondaryFontSize?.max}
          step={secondaryFontSize?.step}
          isDisabled={false}
        />
      </SliderContainer>

      <SliderContainer>
        <SliderLabel>{i18n.t(`${TRANSLATION}.body_label`)}</SliderLabel>
        <GenericAbsoluteSlider
          value={bodyFontSize.value}
          defaultValue={bodyFontSize?.defaultValue}
          onChange={bodyFontSize.onChange}
          unit=" pt"
          isIntermediateDotsDisabled
          min={bodyFontSize?.min}
          max={bodyFontSize?.max}
          step={bodyFontSize?.step}
          isDisabled={false}
        />
      </SliderContainer>

      <SliderContainer>
        <SliderLabel>{i18n.t(`${TRANSLATION}.section_titles_label`)}</SliderLabel>
        <GenericAbsoluteSlider
          value={sectionTitleFontSize.value}
          defaultValue={sectionTitleFontSize?.defaultValue}
          onChange={sectionTitleFontSize.onChange}
          unit=" pt"
          isIntermediateDotsDisabled
          min={sectionTitleFontSize?.min}
          max={sectionTitleFontSize?.max}
          step={sectionTitleFontSize?.step}
          isDisabled={false}
        />
      </SliderContainer>
    </Fragment>
  )
}
